import { getInitialData } from "common/utils/initialization";
import { IntegrationSettings } from "common/types/accounts";
import type { PostHogAnalyticsUser } from "common/contexts/PostHogAnalyticsProvider";

import { Clinic } from "client/clinics/types";
import { AuthenticationSource } from "client/accounts/types";

/** matches general ClientBundle initial_data */
type InitialData = {
  clinic: Clinic;
  is_authenticated: boolean;
  auth_source: AuthenticationSource | null;
  has_completed_signup: boolean;
  is_staff: boolean;
  vetcove_support_phone: number;
  vetcove_support_email: string;
  vetcove_support_hours: string;
  vetcove_phone_support_hours: string;
  user_id: number | null;
  user: PostHogAnalyticsUser | null;
  intercom_id: string;
  intercom_user_hash: string | null;
  integration_settings: IntegrationSettings;
  has_internal_analytics_tracking: boolean;
  debug_analytics_events: boolean;
};

export const INITIAL_CLIENT_DATA = getInitialData<InitialData>();
